// extracted by mini-css-extract-plugin
export var logos = "Logos-module--logos--Szf1g";
export var logoWrapper = "Logos-module--logoWrapper--jMTMC";
export var isMobile = "Logos-module--isMobile--z+3uw";